"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _utils = require("./../../../configuration/utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var AccordionRowLink = function AccordionRowLink(_ref) {
  var toggleAccordion = _ref.toggleAccordion,
      currIndex = _ref.currIndex,
      item = _ref.item,
      title = _ref.title,
      index = _ref.index;
  return /*#__PURE__*/_react["default"].createElement("a", {
    className: "accordion-pep-feature__title white",
    key: index + 10,
    tabIndex: 5,
    onKeyPress: function onKeyPress(e) {
      return e.key === 'Enter' ? toggleAccordion(currIndex) : null;
    },
    onClick: function onClick() {
      return toggleAccordion(currIndex);
    }
  }, item.image && /*#__PURE__*/_react["default"].createElement("img", {
    src: item.image.url
  }), /*#__PURE__*/_react["default"].createElement("h3", {
    style: {
      color: 'white',
      marginBottom: 0
    }
  }, title, " ", item.technicalDescription ? item.technicalDescription : ''));
};

var AccordionContent = function AccordionContent(_ref2) {
  var index = _ref2.index,
      val = _ref2.val,
      isActive = _ref2.isActive,
      contentFontRegular = _ref2.contentFontRegular;
  return /*#__PURE__*/_react["default"].createElement("div", {
    key: index,
    tabIndex: isActive ? 5 : -1,
    style: {
      display: 'inline-block'
    }
  }, val && /*#__PURE__*/_react["default"].createElement("p", {
    className: "accordion-pep-feature__section ".concat(contentFontRegular ? 'font-regular' : ''),
    style: {
      padding: 0,
      paddingBottom: 10
    }
  }, val));
};

var AccordionComponent = function AccordionComponent(_ref3) {
  var activeOnLoad = _ref3.activeOnLoad,
      element = _ref3.element,
      elementsObj = _ref3.elementsObj,
      currIndex = _ref3.currIndex,
      contentFontRegular = _ref3.contentFontRegular;

  var _useState = (0, _react.useState)(activeOnLoad ? activeOnLoad : 0),
      _useState2 = _slicedToArray(_useState, 2),
      activeRow = _useState2[0],
      setActiveRow = _useState2[1];

  var toggleAccordion = function toggleAccordion(index) {
    var eventLabel = currIndex !== activeRow ? parseFloat(currIndex) + 1 + ' open' : parseFloat(currIndex) + 1 + ' close';
    document.querySelector('.pep-product-details') ? (0, _utils.sendDataLayerEvent)('Accordion Benefits', eventLabel) : (0, _utils.sendDataLayerEvent)('Accordion', eventLabel(eventLabel));
    setActiveRow(currIndex !== activeRow ? index : null);
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: activeRow === currIndex ? "accordion-pep-feature active" : 'accordion-pep-feature',
    "aria-expanded": activeRow === currIndex ? "true" : 'false',
    key: currIndex + 10
  }, /*#__PURE__*/_react["default"].createElement(AccordionRowLink, {
    title: element,
    currIndex: currIndex,
    item: element,
    toggleAccordion: toggleAccordion
  }), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      maxWidth: '100%',
      display: 'grid',
      gridTemplateColumns: '1fr 1fr 1fr',
      gridAutoFlow: 'row',
      gridColumnGap: 10
    }
  }, elementsObj.map(function (val, index) {
    return val.name.indexOf(element) > -1 && /*#__PURE__*/_react["default"].createElement(AccordionContent, {
      index: index,
      val: val.name,
      key: index + 5,
      isActive: activeRow === currIndex ? 5 : -1,
      contentFontRegular: contentFontRegular
    });
  })));
};

var _default = AccordionComponent;
exports["default"] = _default;